import { setComponentMapOverrides } from '@jutro/uiconfig';
import 'gw-capability-policychange-common-react';
import FarmPolicyChangesPage from './pages/PolicyChanges/PolicyChangesPage';
import FarmAddressPage from './pages/Address/AddressPage';
import FarmItemDetailsPage from './pages/ItemDetails/ItemDetailsPage';
import PCFARMQuotePage from './pages/Quote/QuotePage';
import PCFARMFarmerDetailsPage from './pages/FarmerDetails/FarmerDetailsPage';
import './FARMPolicyChange.messages';


setComponentMapOverrides(
    {
        FarmPolicyChangesPage: { component: 'FarmPolicyChangesPage' },
        FarmAddressPage: { component: 'FarmAddressPage' },
        FarmItemDetailsPage: { component: 'FarmItemDetailsPage' },
        PCFARMQuotePage: { component: 'PCFARMQuotePage' },
        PCFARMFarmerDetailsPage: { component: 'PCFARMFarmerDetailsPage' }
    },
    {
        FarmPolicyChangesPage,
        FarmAddressPage,
        FarmItemDetailsPage,
        PCFARMQuotePage,
        PCFARMFarmerDetailsPage
    }
);
// eslint-disable-next-line import/prefer-default-export
export { default as FARMPolicyChangeWizard } from './FARMPolicyChangeWizard';
export {default as AdditionalInsuredInterestComponent} from './components/AdditionalInsuredInterest/AdditionalInsuredInterestComponent';